import { render, staticRenderFns } from "./CurrentFilters.vue?vue&type=template&id=66133bd6&scoped=true&"
import script from "./CurrentFilters.vue?vue&type=script&lang=ts&"
export * from "./CurrentFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentFilters.vue?vue&type=style&index=0&id=66133bd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66133bd6",
  null
  
)

export default component.exports